import Marquee from "react-fast-marquee";
import { Trophy, Award, Stamp } from "lucide-react";

const ACHIEVEMENTS = [
  { type: "sch", icon: Award, text: "Sneha K. · $45K Scholarship · Stanford" },
  { type: "score", icon: Trophy, text: "Priya S. · IELTS 8.5" },
  { type: "sch", icon: Award, text: "Kabir V. · £28K Scholarship · Oxford" },
  { type: "visa", icon: Stamp, text: "Ananya D. · USA F-1 Visa Approved" },
  { type: "sch", icon: Award, text: "Ishaan T. · €32K Scholarship · Trinity" },
  { type: "visa", icon: Stamp, text: "Riya M. · UK Visa Approved" },
  { type: "score", icon: Trophy, text: "Aditya B. · TOEFL 118" },
  { type: "sch", icon: Award, text: "Nidhi J. · A$38K Scholarship · Melbourne" },
  { type: "visa", icon: Stamp, text: "Karan S. · Australia Visa Approved" },
  { type: "score", icon: Trophy, text: "Tanvi G. · PTE 85" },
  { type: "sch", icon: Award, text: "Manan P. · $60K Scholarship · CMU" },
  { type: "visa", icon: Stamp, text: "Zara K. · Ireland Visa Approved" },
  { type: "score", icon: Trophy, text: "Dhruv A. · DET 145" },
  { type: "sch", icon: Award, text: "Meher S. · $25K Scholarship · UC Berkeley" },
  { type: "visa", icon: Stamp, text: "Yash R. · New Zealand Visa Approved" },
];

function Chip({ item }) {
  const { type, icon: Icon, text } = item;
  const palette = {
    score: {
      wrap: "bg-[#c92e34] text-white border-[#282829]",
      badge: "bg-white text-[#c92e34] border-[#282829]",
    },
    sch: {
      wrap: "bg-[#282829] text-white border-[#282829]",
      badge: "bg-[#c92e34] text-white border-white",
    },
    visa: {
      wrap: "bg-white text-[#282829] border-[#282829]",
      badge: "bg-[#282829] text-white border-[#282829]",
    },
  }[type];

  return (
    <div
      className={`inline-flex items-center gap-2.5 mx-2 md:mx-3 px-5 py-3 rounded-full border-2 min-w-max shadow-[4px_4px_0_0_#282829] ${palette.wrap}`}
    >
      <span className={`w-9 h-9 rounded-full grid place-items-center flex-shrink-0 border-2 ${palette.badge}`}>
        <Icon size={15} strokeWidth={2.8} />
      </span>
      <span className="font-anton text-lg md:text-xl tracking-wide uppercase whitespace-nowrap">
        {text}
      </span>
    </div>
  );
}

export default function AchievementsRoller() {
  return (
    <section
      className="py-8 bg-white border-b-[3px] border-[#282829] overflow-hidden"
      data-testid="achievements-roller"
    >
      <Marquee gradient={false} speed={60} pauseOnHover>
        {ACHIEVEMENTS.map((a, i) => (
          <Chip key={a.text + i} item={a} />
        ))}
      </Marquee>
    </section>
  );
}
